export default __webpack_public_path__ + "static/media/heating.d2cca769.png";